import IdenfitConnector from "./api/connector/IdenfitConnector";
import HiringConnector from "./api/connector/HiringConnector";

export const idenfitConnector = new IdenfitConnector(process.env.VUE_APP_BASE_URL);
export const hiringConnector = new HiringConnector(process.env.VUE_APP_HIRING_BASE_URL);
